import { Service } from "@/api";

export const getWebsiteDynamic=(params)=> {
    console.log('data'+JSON.stringify(params))
    return Service({
        url: 'api/websiteDynamic',
        params
    })
}
